import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-eb6aaa3e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "suggestion-container" }
const _hoisted_2 = { class: "thumbnail-container" }
const _hoisted_3 = { class: "info-text ml-3 mb-2" }
const _hoisted_4 = { class: "name-text" }
const _hoisted_5 = {
  class: "subtitle is-6 part-number",
  style: {"margin-bottom":"0"}
}
const _hoisted_6 = {
  key: 0,
  class: "tag is-primary is-medium"
}
const _hoisted_7 = { class: "cart-controls" }

import { inject } from "vue"
import { PartSuggestion } from "@/interfaces/library/part"
import AddToCart from "@/components/library/content/info/AddToCart.vue"
import Thumbnail from "@/components/common/StatelessThumbnail.vue"

//@ts-ignore
type PartSuggestionWithQuantity = PartSuggestion & {
  quantity: number,
  quantityInCart: number
}
type Props = {
  source: PartSuggestionWithQuantity,
  isWidget: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'BomCartSuggestion',
  props: {
    source: {},
    isWidget: { type: Boolean }
  },
  setup(__props: any) {

const { updatePartSuggestionQuantity } = inject("partSuggestionQuantity")



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("article", {
      class: _normalizeClass(["product-info is-flex is-align-items-center", { 'mb-5': !_ctx.source.quantityInCart }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(Thumbnail, {
          "thumbnail-url": _ctx.source.thumbnailUrl,
          "thumbnail-type": "part",
          isWidget: _ctx.isWidget,
          class: "is-48x48"
        }, null, 8, ["thumbnail-url", "isWidget"])
      ]),
      _createElementVNode("article", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.source?.name), 1),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.source?.partNumber), 1),
        (_ctx.source.quantityInCart)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.$t('inCart')) + ": " + _toDisplayString(_ctx.source.quantityInCart), 1))
          : _createCommentVNode("", true)
      ])
    ], 2),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(AddToCart, {
        quantity: _ctx.source.quantity,
        "onUpdate:quantity": [
          _cache[0] || (_cache[0] = ($event: any) => ((_ctx.source.quantity) = $event)),
          _cache[1] || (_cache[1] = ($event: any) => (_unref(updatePartSuggestionQuantity)(_ctx.source.id, $event)))
        ],
        expanded: true,
        "include-add-btn": false
      }, null, 8, ["quantity"])
    ])
  ]))
}
}

})